import { DatasheetSelection } from "../../common/DatasheetSelection";
import { defaultState } from "./types";
import { InspectorContext, reducer } from "./reducer";
import { MainInterface } from "./components/MainInterface";
import { useReducer } from "react";
import { useSearchParams } from "react-router-dom";
import { WeldSelection } from "./components/WeldSelection";

export function CDSInspectorRole() {
  const [state, updateState] = useReducer(reducer, defaultState);
  const [searchParams] = useSearchParams();

  const currentPage = Number(searchParams.get("page")) || 1;

  return (
    <InspectorContext.Provider value={{ state, updateState }}>
      {currentPage === 1 && <DatasheetSelection updateState={updateState} {...state} />}
      {currentPage === 2 && <WeldSelection />}
      {currentPage === 3 && <MainInterface />}
    </InspectorContext.Provider>
  );
}
